import React, { Component } from 'react';
import Favorite from './Favorite/index.jsx';
import SocialSharingWidgets from './SocialSharingWidgets.jsx';
import BrandLogo from '@xo-union/component-brand-logo';

const defaultProps = {
  title: '',
  shareTrackingData: {},
  favoriteTrackingData: {},
  favorite_params: '',
  entityId: '',
}

export default class StickyHead extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showStickyHeader: false,
      notHideStickyHeader: false,
    }
  }

  componentDidMount () {
    let _this = this;

    document.addEventListener("scroll", function() {
      let headerHeight = $('nav.header-nav').outerHeight();
      _this.setState({ showStickyHeader: $(window).scrollTop() > headerHeight })
    })
  }

  closePopup = () => {
    this.setState({}, () => {
      this.setState({ notHideStickyHeader: false });
    })
  }

  notHideStickyHeader = () => {
    this.setState({ notHideStickyHeader: true })
  }

  render() {
    const { title, shareTrackingData, favoriteTrackingData, favorite_params, entityId, portalSticky } = this.props;
    const { showStickyHeader, notHideStickyHeader } = this.state;
    return(
      <div className="bride-social-buttons text-center sticky sticky-top" style={{ display: showStickyHeader || notHideStickyHeader ? 'block' : 'none' }}>
        <div className="sticky-inner clearfix">
          <div className="social-container">
            <div className="favorite-button">
              { !portalSticky ? <Favorite classes='btn btn-alternate heart' border='box' trackingData={favoriteTrackingData} favorite_params={favorite_params} id={entityId} closePopup={this.closePopup} notHideStickyHeader={this.notHideStickyHeader} inStickyHeader={true} /> : <div id={entityId}></div>}
              
            </div>
            <SocialSharingWidgets source='sticky social bar' trackingData={shareTrackingData} title={title} />
          </div>
          <div className="logo">
            <a href='/'>
              <BrandLogo
                name="theknot"
                size="lg"
                color='primary'
                className='sticky-head-logo'
              />
            </a>
          </div>
          <div className="social-container-title">{title}</div>
        </div>
      </div>
    )
  }
}

StickyHead.defaultProps = defaultProps
